import React, { createRef } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import InputCustom from '../../../../components/InputCustom';
import request from '../../../../api/request';
import debounce from '../../../../helpers/utils/debounce';

import { displayNotificationAction } from '../../../notifications/actions';

const SerialNumber = ({
  displayNotification,
  serialNumber,
  graspId,
  organizationId,
  intl,
  disabled,
}) => {
  const inputRef = createRef();

  const changeGraspSerialNumber = (value) =>
    request({
      url: `/organizations/${organizationId}/grasps/${graspId}`,
      method: 'PATCH',
      data: {
        serial_number: value,
      },
    })
      .then(() => displayNotification({ code: 'serialnumber_updated' }))
      .catch((error) => {
        if (
          error.data.meta.errors.find(
            (err) => err.code === 'serial_number_already_exists_error'
          )
        ) {
          inputRef.current.value = serialNumber;
          displayNotification({ code: 'serialnumber_already_exist' });
        }
      });

  const debouncedChangeGraspSerialNumber = debounce(
    changeGraspSerialNumber,
    750
  );

  const handleChange = (e) => {
    debouncedChangeGraspSerialNumber(e.target.value);
  };

  return (
    <td className="text-center">
      <InputCustom
        innerRef={inputRef}
        style={{ width: '150px' }}
        autoComplete="false"
        disabled={!organizationId || disabled}
        onChange={handleChange}
        defaultValue={serialNumber}
        placeHolder={
          !serialNumber
            ? intl.formatMessage({ id: 'GraspInventory.table.notAssigned' })
            : undefined
        }
      />
    </td>
  );
};

const mapDispatchToProps = {
  displayNotification: displayNotificationAction,
};

export default connect(null, mapDispatchToProps)(injectIntl(SerialNumber));
